import { Alert, AlertTitle, Typography } from '@mui/material';

import { useQuery } from '@redwoodjs/web';

import { GET_SERVICE_TRIAL_STATUS } from 'src/graphql/queries/merchantServices.query';
import { formatDate } from 'src/utils/utils';

type ServiceTrialStatusProps = {
    serviceId: number;
};

const ServiceTrialStatus = ({ serviceId }: ServiceTrialStatusProps) => {
    const { data, loading } = useQuery(GET_SERVICE_TRIAL_STATUS, {
        skip: !serviceId,
        variables: { serviceId },
    });

    if (loading) {
        return null;
    }

    const { serviceTrialStatus } = data ?? {};

    if (!serviceTrialStatus?.onTrial) {
        return null;
    }

    return (
        <Alert
            severity="warning"
            icon={false}
            variant={'filled'}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <AlertTitle variant={'h4'}>This service is currently in a Trial Period</AlertTitle>
            <Typography variant={'body2'}>
                The trial for this service is due to end{' '}
                {formatDate({ date: serviceTrialStatus?.trialEndDate })}
            </Typography>
        </Alert>
    );
};

export default ServiceTrialStatus;
